
import { Outlet, Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import { CreditLogProvider } from 'contexts/credit_log_context';
import { PaymentProvider } from 'contexts/payment_context';
import useRoles from 'hooks/useRoles';
import useUserIdentity from 'hooks/useUserIdentity';
import { getIcon } from 'utils/misc';

const ManagerContainer = observer(() => {
    const SupportAgentIcon = getIcon('SupportAgent');
    //    const location = useLocation();
    const { currentIdentity } = useUserIdentity();
    const { rolesNames } = useRoles();

    const URL = '/manager';

    const isManager = rolesNames.includes('manager') &&
        currentIdentity.role == 'assistant';

    if (!isManager) {
        return null;
    }

    /* Keep in mind, both assistants and clients need support */

    return (
        <CreditLogProvider>
            <PaymentProvider>
                <Stack>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        borderBottom={1}
                        borderColor="divider"
                        sx={
                            theme => ({
                                width: { xs: '100%' },
                                borderBottom: 1,
                                backgroundColor: theme.vars.palette.background.body,
                            })}
                        p={1}
                    >
                        <Link to={URL}>
                            <Typography
                                startDecorator={<SupportAgentIcon />}
                                color="danger"
                                level="title-lg">Manager</Typography>
                        </Link>




                    </Stack>

                    <Stack p={1}>
                        <Outlet />
                    </Stack>

                </Stack>
            </PaymentProvider>
        </CreditLogProvider>
    );

});



export default ManagerContainer;
